import { map } from 'rxjs/operators/map';
import { combineEpics } from 'redux-observable';
import { FetchAttributes, UpdatePhoneNumber, UpdateLanguageWithLocale, UpdateDefaultHome, UpdateDefaultPhoneCountryCode, LOAD_ATTRIBUTES, UPDATE_PHONE_NUMBER, UPDATE_LANGUAGE, UPDATE_LANGUAGE_WITH_LOCALE, UPDATE_DEFAULT_PHONE_COUNTRY_CODE, UPDATE_DEFAULT_HOME } from '../actions/AttributeActions';
import { getCurrentUserLanguage } from '../selectors/AttributesSelector';
import { getFetchAttributesRequestStatus, getUpdatePhoneNumberRequestStatus, getUpdateLanguageRequestStatus, getUpdateDefaultPhoneCountryCodeRequestStatus, getUpdateDefaultHomeRequestStatus } from '../selectors/RequestStatusSelector';
import { getSelectedLocaleFromNewLanguage } from '../selectors/ProfileOptionsSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import AttributesAPI from '../api/AttributesAPI';
import { tap } from 'rxjs/operators/tap';
import { Map as ImmutableMap } from 'immutable';
import { tracker } from 'UserPreferencesUI/lib/tracker';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const LANGUAGES_BY_KEY = ImmutableMap({
  en: 'English',
  es: 'Spanish',
  pt: 'Portuguese',
  de: 'German',
  fr: 'French',
  ja: 'Japanese',
  nl: 'Dutch',
  it: 'Italian'
});
const fetchAttributes = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.getAttributes,
  initiatingActionType: LOAD_ATTRIBUTES,
  requestStatusSelector: getFetchAttributesRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchAttributes
}));
const updateDefaultPhoneCountryCode = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateDefaultPhoneCountryCode,
  initiatingActionType: UPDATE_DEFAULT_PHONE_COUNTRY_CODE,
  requestStatusSelector: getUpdateDefaultPhoneCountryCodeRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateDefaultPhoneCountryCode
}));
const updatePhoneNumber = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updatePhoneNumber,
  initiatingActionType: UPDATE_PHONE_NUMBER,
  requestStatusSelector: getUpdatePhoneNumberRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdatePhoneNumber
}));
const updateLanguageAndLocale = ($action, {
  getState
}) => {
  return $action.ofType(UPDATE_LANGUAGE).pipe(tap(action => {
    const {
      language
    } = action.payload.data;
    const newLanguage = LANGUAGES_BY_KEY.get(language) || language;

    // If the user only updated locale (date/number format), than language didn't change so
    // no need to track anything
    if (newLanguage) {
      tracker.track('changedLanguage', {
        action: 'changed language',
        newLanguage
      });
    }
  }), map(action => {
    let {
      language,
      locale
    } = action.payload.data;
    language = language || getCurrentUserLanguage(getState());
    locale = locale || getSelectedLocaleFromNewLanguage(language)(getState());
    return {
      type: UPDATE_LANGUAGE_WITH_LOCALE,
      payload: {
        data: {
          language,
          locale
        }
      }
    };
  }));
};
const updateLanguageRequest = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateLanguageAndLocale,
  initiatingActionType: UPDATE_LANGUAGE_WITH_LOCALE,
  requestStatusSelector: getUpdateLanguageRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateLanguageWithLocale
}));
const updateDefaultHome = requestEntity(new RequestEpicDescriptor({
  apiFunction: AttributesAPI.updateDefaultHome,
  initiatingActionType: UPDATE_DEFAULT_HOME,
  requestStatusSelector: getUpdateDefaultHomeRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: UpdateDefaultHome
}));
export const updateAttributeEpics = combineEpics(updateDefaultPhoneCountryCode, updatePhoneNumber, updateLanguageAndLocale, updateLanguageRequest, updateDefaultHome);
export default combineEpics(fetchAttributes, updateLanguageAndLocale, updateLanguageRequest);